export default __webpack_public_path__ + "static/media/gridplus.1440678d.jpeg";